import hardware from './hardware.dev'

const commonPlanProperties = {
    group_key: 'pro',
    label: 'Travel Ball',
    description: 'Travel Ball',
    stripe_product_id: 'prod_PU6zRJkzjLARkI',
    badge: '',
    free_hardware: true,
    free_hardware_categories: ['bat_attachment'],
    includes_coaching: false,
    hardware_options: hardware.filter((h) => h.category === 'bat_attachment' && h.price === 0),
    is_travel_ball: true,
}

const monthlyPlan = {
    ...commonPlanProperties,
    map_key: 'pro_monthly',
    billing_interval: 'monthly',
    price: 3900,
    price_monthly: 3900,
}

const yearlyPlan = {
    ...commonPlanProperties,
    map_key: 'pro_yearly',
    billing_interval: 'yearly',
    price: 35500,
    price_monthly: 2958,
}

export default {
    'power-baseball': {
        name: 'Power Baseball',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1Of8lnIDrm6Z6HgYSnsyF05b',
                price: 4000,
                price_monthly: 4000,
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OrNGyIDrm6Z6HgYHzZMkGod',
            } as StripePlan,
        ],
    },
    'slammers': {
        name: 'Slammers',
        coupon: 'slammers1',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OgWxsIDrm6Z6HgYc9Vf0zCI',
                price: 4000,
                price_monthly: 4000,
            } as StripePlan,
            // {
            //     ...yearlyPlan,
            //     stripe_price_id: 'price_1OrNHIIDrm6Z6HgYvGw62GCW',
            // } as StripePlan,
        ],
    },
    'dulins-dodgers': {
        name: 'Dulins Dodgers',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P5aX2IDrm6Z6HgYvACzMQT1',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OrNHZIDrm6Z6HgYBSCA0uYW',
            } as StripePlan,
        ],
    },
    'iowa-sticks': {
        name: 'Iowa Sticks',
        coupon: 'iowasticks1',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OjOVoIDrm6Z6HgYKra1818s',
                price: 4000,
                price_monthly: 4000,
            } as StripePlan,
        ],
    },
    'marucci-elite': {
        name: 'Marucci Elite',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OmO3MIDrm6Z6HgYTZCbMttx',
                price: 4000,
                price_monthly: 4000,
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OrNIUIDrm6Z6HgYCfbbrc1I',
            } as StripePlan,
        ],
    },
    'hunter-pence': {
        name: 'Hunter Pence',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OlxihIDrm6Z6HgYbEWtHxiP',
                price: 4000,
                price_monthly: 4000,
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OrNIFIDrm6Z6HgYR7GqjnhG',
            } as StripePlan,
        ],
    },
    'east-coast-development': {
        name: 'East Coast Sox',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1Olxi0IDrm6Z6HgYsJuIORyf',
                price: 4000,
                price_monthly: 4000,
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OrNI3IDrm6Z6HgYmXCyRI6c',
            } as StripePlan,
        ],
    },
    'p2p-millers': {
        name: 'P2P Millers',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1Oo7WUIDrm6Z6HgYSMl52eNf',
                price: 4000,
                price_monthly: 4000,
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OrNIkIDrm6Z6HgY5sAYDv31',
            } as StripePlan,
        ],
    },
    'twelve-degree-launch': {
        name: 'Twelve Degree Launch',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OrNDRIDrm6Z6HgYsfpCZ9Zp',
                price: 4000,
                price_monthly: 4000,
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OrNJ5IDrm6Z6HgYFOPDEJzj',
            } as StripePlan,
        ],
    },
    '5-star': {
        name: '5 Star',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1Os8fIIDrm6Z6HgYt4bn0tFZ',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1Os8flIDrm6Z6HgY7xpQtsbN',
            } as StripePlan,
        ],
    },
    'east-cobb': {
        name: 'East Cobb',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OtFXpIDrm6Z6HgY6ozbzySs',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OtFY7IDrm6Z6HgYWMK3BShU',
            } as StripePlan,
        ],
    },
    'exposure': {
        name: 'eXposure',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXG5IDrm6Z6HgYTAxPh5hs',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXGCIDrm6Z6HgYqBzOWtuj',
            } as StripePlan,
        ],
    },
    'cba': {
        name: 'CBA',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXI5IDrm6Z6HgYHMkrRrxR',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXIDIDrm6Z6HgYClZmUCBX',
            } as StripePlan,
        ],
    },
    'hardcore-elite': {
        name: 'Hardcore Elite',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXIOIDrm6Z6HgYTcnyUYKO',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXIXIDrm6Z6HgYLvlCDqmE',
            } as StripePlan,
        ],
    },
    'lonestar': {
        name: 'Lonestar',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXJMIDrm6Z6HgY6WfJ4pzz',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXJcIDrm6Z6HgY7xFE5ipb',
            } as StripePlan,
        ],
    },
    '3-step': {
        name: '3 Step',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXMHIDrm6Z6HgY74ZS4COi',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXMQIDrm6Z6HgYL2MPhCiZ',
            } as StripePlan,
        ],
    },
    'knights-knation': {
        name: 'Knights Knation',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXMaIDrm6Z6HgYkgNHW84i',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXMlIDrm6Z6HgYg3hHODfP',
            } as StripePlan,
        ],
    },
    'grb-rays': {
        name: 'GRB Rays',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXMzIDrm6Z6HgY347GK9mH',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXN8IDrm6Z6HgYuslBRKxZ',
            } as StripePlan,
        ],
    },
    'gbg': {
        name: 'GBG',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXNIIDrm6Z6HgYmrH0G1dG',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXNTIDrm6Z6HgYdnMPFALD',
            } as StripePlan,
        ],
    },
    'ebc': {
        name: 'EBC',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXNcIDrm6Z6HgY6wnPIDOQ',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXNmIDrm6Z6HgYyL77al0o',
            } as StripePlan,
        ],
    },
    'team-elite': {
        name: 'Team Elite',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXnkIDrm6Z6HgYoFOhj5EG',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXnvIDrm6Z6HgYq6fsgtHg',
            } as StripePlan,
        ],
    },
    'indiana-bulls': {
        name: 'Indiana Bulls',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXoJIDrm6Z6HgY0BxtmX3A',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXoSIDrm6Z6HgYOheCwcnI',
            } as StripePlan,
        ],
    },
    'select1': {
        name: 'WIN Player Development Program',
        alias: 'All Star Sports Academy',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXoiIDrm6Z6HgYZfubDk8H',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXoqIDrm6Z6HgYT9tuND0d',
            } as StripePlan,
        ],
    },
    'the-show-new-england': {
        name: 'The Show New England',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OwXLvIDrm6Z6HgYDP77u9YM',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OwXM5IDrm6Z6HgY0wUbKHKI',
            } as StripePlan,
        ],
    },
    'noreasters': {
        name: 'Nor\'Easters',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OzOGnIDrm6Z6HgYOlB8A2Ns',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OzOGzIDrm6Z6HgYGwgrJqbX',
            } as StripePlan,
        ],
    },
    'prospects-athletics': {
        name: 'Prospects Athletics',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OzOHHIDrm6Z6HgYLgf26OCQ',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OzOHPIDrm6Z6HgY3cw4tp3b',
            } as StripePlan,
        ],
    },
    'bay-sox': {
        name: 'Bay Sox',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OzOJ3IDrm6Z6HgY8QB9F0Gq',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OzOJHIDrm6Z6HgY0TkTZTEr',
            } as StripePlan,
        ],
    },
    'seacoast': {
        name: 'Seacoast',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OzOMKIDrm6Z6HgYcPVrw06j',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OzOMbIDrm6Z6HgYbUh2xNWh',
            } as StripePlan,
        ],
    },
    'northeast-hurricanes': {
        name: 'Northeast Hurricanes',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OzOO4IDrm6Z6HgY45l7vedj',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OzOOFIDrm6Z6HgYqmR4iNyg',
            } as StripePlan,
        ],
    },
    'midland': {
        name: 'Midland',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1OzPPTIDrm6Z6HgYZsozeCWI',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1OzPPdIDrm6Z6HgYRGUVMcQ2',
            } as StripePlan,
        ],
    },
    'grb-stiks': {
        name: 'GRB STiKS',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P2Hb0IDrm6Z6HgYa3jDT9FA',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P2HbEIDrm6Z6HgYkashcvv4',
            } as StripePlan,
        ],
    },
    'grb-illinois': {
        name: 'GRB Illinois',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P2He9IDrm6Z6HgYgkXEWgcA',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P2HeIIDrm6Z6HgYj51u1BRb',
            } as StripePlan,
        ],
    },
    'grb-northstar': {
        name: 'GRB Northstar',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P2HekIDrm6Z6HgYA4mokjSw',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P2HetIDrm6Z6HgYjIDKAl2u',
            } as StripePlan,
        ],
    },
    'grb-dakota-select': {
        name: 'GRB Dakota Select',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P2HfDIDrm6Z6HgYTMjTYbrG',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P2HfQIDrm6Z6HgYOR2ATdIK',
            } as StripePlan,
        ],
    },
    'clubhouse-ct': {
        name: 'Clubhouse CT',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P3mrRIDrm6Z6HgYGsdugqhT',
                price: 9900,
                price_monthly: 9900,
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P3mrnIDrm6Z6HgY4wn2aL0z',
                price: 99900,
                price_monthly: 8325,
            } as StripePlan,
        ],
    },
    'wildcats-baseball': {
        name: 'Wildcats Baseball',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P3ms9IDrm6Z6HgYoW2PK3Ll',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P3msPIDrm6Z6HgY2q7VPzCB',
            } as StripePlan,
        ],
    },
    'original-florida-pokers': {
        name: 'Original Florida Pokers',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P3mslIDrm6Z6HgY6937NJpY',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P3mu5IDrm6Z6HgYyEvl3ZwX',
            } as StripePlan,
        ],
    },
    'midland-marlins': {
        name: 'Midland Marlins',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P3myEIDrm6Z6HgY2IKwF2CS',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P3myPIDrm6Z6HgYTddPQYtb',
            } as StripePlan,
        ],
    },
    'cooperstown-cobras': {
        name: 'Cooperstown Cobras',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P3mykIDrm6Z6HgYSG1u3VM9',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P3mzQIDrm6Z6HgYuZz23EvV',
            } as StripePlan,
        ],
    },
    'canes': {
        name: 'Canes',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P3pNRIDrm6Z6HgYOLnxo3WY',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P3pNcIDrm6Z6HgYRkueZtRG',
            } as StripePlan,
        ],
    },
    'd-bat': {
        name: 'D-Bat',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P3pOFIDrm6Z6HgYXQnI2mok',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P3pOSIDrm6Z6HgYUWkS4CHx',
            } as StripePlan,
        ],
    },
    'select2': {
        name: 'WIN Player Development Program',
        alias: 'Tim Dulin',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P5adcIDrm6Z6HgYmUwLywVg',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P5ae2IDrm6Z6HgYIHgTwWW0',
            } as StripePlan,
        ],
    },
    'select3': {
        name: 'WIN Player Development Program',
        alias: 'Baseball USA',
        plans: [
            {
                ...monthlyPlan,
                stripe_price_id: 'price_1P6b9RIDrm6Z6HgYdbzxkt5R',
            } as StripePlan,
            {
                ...yearlyPlan,
                stripe_price_id: 'price_1P6b9cIDrm6Z6HgYBuZitN4W',
            } as StripePlan,
        ],
    },
} as Record<string, Org>
